import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  EventEmitter,
  Output,
  ViewChild
} from '@angular/core';
import {
  LoginInput,
  eAppContext,
  QueovalDik,
  CheckInput,
  LoginOut,
  eLogOutMode,
  LoginExtranetAppModel,
  ExternalLoginModel,
  ExternalGoogle,
  ExternalMS
} from '../models';
import { CoreService } from '../services';
import { CommonLoginService } from './common.login.service';
import { Subscription } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { b64EncodeUnicode, b64DecodeUnicode } from '../utilities';
import { VirtualNumPadComponent } from './virtual-num-pad';

@Component({
  selector: 'q-comp-login',
  templateUrl: './common.login.component.html',
  styleUrls: ['./common.login.component.css']
})

export class CommonLoginComponent implements OnInit, OnDestroy {

  private result: Subscription[] = [];
  private inputData: LoginInput;

  isLoading: boolean = false;
  isLogin: boolean = true;
  user: string = '';      // user data for login mode
  // pswd: string = ''; // password data for the login mode
  recoveryuser: string = '';
  recoverymail: string = '';
  recoverydb: string = '';
  recoveryuseralert: string = '';
  recoverymailalert: string = '';
  recoverydbalert: string = '';

  logoUrl: string = '';

  clientDB: string = '';
  inputChk: CheckInput = new CheckInput();

  showInputDB: boolean = false;

  @Input('data')
  set data(value: LoginInput) {
    if (value) {
      this.inputData = value;
      this.logoUrl = this.inputData.bigLogoUrl;
      this.clientDB = this.inputData.NameDB;
      this.showInputDB = this.inputData.CheckDB && this.clientDB === '';
    }
  }

  @Input('user') pUser: string = '';
  @Input('password') pPassword: string = '';
  @Input('enableNumpad') enableNumpad: boolean | undefined = undefined;

  @Output('logo') logo: EventEmitter<string> = new EventEmitter<string>();
  @Output('handleRedirection') handleRedirection: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('numPad') numPad: VirtualNumPadComponent; // password data for the login mode

  constructor(
    private indParam: CoreService,
    private login: CommonLoginService,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {

    this.indParam.showSplash(true);

    this.result.push(this.login.getConfig(this.inputData).subscribe((result: QueovalDik) => {
      if (result.key !== 'OK') {
        this.login.setAlert(result.value);
      }
      else {
        const img: string[] = result.value.split('|')
        this.logoUrl = img[1] ? img[1] : './assets/images/queoval_logo.png';
        this.logo.emit(img[0] ? img[0] : './assets/images/queoval_logo.png');
      }

      if (this.pUser != '' && this.pPassword != '') {
        this.isLoading = true;
        this.result.push(this.login.Log(this.inputData.Context, this.pUser, this.pPassword, this.clientDB, true).subscribe((result: string) => {
          this.sendAlert(result);
          switch (this.inputData.Context) {
            case eAppContext.LOGINEX:
              this.login.setLoginResult(new LoginOut(result === 'OK', eLogOutMode.EXTRANET));
              break;
            case eAppContext.LOGINEL:
              this.login.setLoginResult(new LoginOut(result === 'OK', eLogOutMode.ELEARNING));
              break;

          }
        }));
      }

      this.indParam.showSplash(false);
    }));
  }

  ngOnDestroy(): void {
    if (this.result) {
      // unsubscribe to ensure no memory leaks
      this.result.forEach((subscription: Subscription) => subscription.unsubscribe());
    }
  }

  redirectTo($event: string) {
    this.handleRedirection.emit($event);
  }

  checkInput(): void {
    this.inputChk.check(this.user, this.numPad.pswd, this.clientDB, this.inputData.CheckDB);
  }

  logUser(): void {
    this.inputChk.check(this.user, this.numPad.pswd, this.clientDB, this.inputData.CheckDB);
    if (this.inputChk.CheckOK) {
      this.indParam.showSplash(true);
      this.result.push(this.login.Log(this.inputData.Context, this.user, this.numPad.pswd, this.clientDB).subscribe((result: string) => {
        console.log(`LOGIN-RESULT: ${result} - [common.login.component]`);
        this.sendAlert(result);
        switch (this.inputData.Context) {
          case eAppContext.LOGINEL:
          case eAppContext.ELEARNING:
            this.login.setLoginResult(new LoginOut(result === 'OK', eLogOutMode.ELEARNING));
            break;
          case eAppContext.LOGINEX:
          case eAppContext.EXTRANET:
            this.login.setLoginResult(new LoginOut(result === 'OK', eLogOutMode.EXTRANET));
            break;
          case eAppContext.QUESTIONNAIRE:
            this.login.setLoginResult(new LoginOut(result === 'OK', eLogOutMode.QUESTIONNAIRE));
            break;
          case eAppContext.QUEOVAL:
            if (result === 'OK') {
              this.login.openView('/baselist');
            }
            break;
          case eAppContext.ONLINEMARKET:
            this.login.setLoginResult(new LoginOut(result === 'OK', eLogOutMode.ONLINEMARKET));
            break;
        }
      }));
    }
  }

  logGoogle(): void {
    this.indParam.showSplash(true);
    const destUrl: string = `${this.indParam.AppParams.apiLogin}api/externallogin/getdata/GOOGLE/${this.clientDB}`;
    this.result.push(this.http.get<ExternalLoginModel>(destUrl).subscribe((data: ExternalLoginModel) => {
      const model: ExternalLoginModel = data;
      const loginUrl: string = this.indParam.AppLoginSite.replace('/#/{0}/{1}', ''); //this.indParam.getStocked('loginurl', true);
      model.Google.RedirectUri = b64EncodeUnicode(loginUrl);
      // in case of google authentication, we are redirect to the google login page and the returned to the login app.component.ts
      // => we need to stock the external login model and the GlobalParams in local storage to recover them on returning
      localStorage.setItem('elm', JSON.stringify(model));
      localStorage.setItem('gap', JSON.stringify(this.indParam.AppParams));
      // -------------------------------------------------------------------------------------------------------------------------
      const eg: ExternalGoogle = data.Google;
      const url: string = `${b64DecodeUnicode(eg.Url)}?client_id=${eg.ClientID}&redirect_uri=${loginUrl}&response_type=${eg.ResponseType}&scope=${b64DecodeUnicode(eg.Scope)}&state=${eg.State}&access_type=${eg.AccessType}`;
      window.location.href = url;
    }));
  }

  logMS(): void {
    this.indParam.showSplash(true);
    const destUrl: string = `${this.indParam.AppParams.apiLogin}api/externallogin/getdata/MS/${this.clientDB}`;
    this.result.push(this.http.get<ExternalLoginModel>(destUrl).subscribe((data: ExternalLoginModel) => {
      const model: ExternalLoginModel = data;
      const loginUrl: string = this.indParam.AppLoginSite.replace('/#/{0}/{1}', ''); //this.indParam.getStocked('loginurl', true);
      model.Microsoft.RedirectUri = b64EncodeUnicode(loginUrl);
      // in case of microsoft authentication, we are redirect to the microsoft login page and the returned to the login app.component.ts
      // => we need to stock the external login model and the GlobalParams in local storage to recover them on returning
      localStorage.setItem('elm', JSON.stringify(model));
      localStorage.setItem('gap', JSON.stringify(this.indParam.AppParams));
      // -------------------------------------------------------------------------------------------------------------------------------
      const em: ExternalMS = data.Microsoft;
      const url: string = `${b64DecodeUnicode(em.Url)}?client_id=${em.ClientID}&response_type=${em.ResponseType}&redirect_uri=${loginUrl}&response_mode=${em.ResponseMode}&scope=${em.Scope}&state=${em.State}`;
      window.location.href = url;
    }));
  }

  recoverPsw(): void {
    this.isLogin = false;
    this.recoveryuser = this.user;
    this.recoverymail = '';
    this.recoverydb = this.clientDB;
    this.recoveryuseralert = '';
    this.recoverymailalert = '';
    this.recoverydbalert = '';
  }

  backLogin(): void {
    this.isLogin = true;
    this.recoveryuser = '';
    this.recoverymail = '';
    this.recoverydb = '';
    this.recoveryuseralert = '';
    this.recoverymailalert = '';
    this.recoverydbalert = '';
  }

  sendPswdRequest(): void {
    if (this.checkRecovery()) {
      this.indParam.showSplash(true);
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Queoval', this.recoverydb);

      this.result.push(this.http.get<LoginExtranetAppModel>(`${this.indParam.AppParams.apiLogin}api/loginapp/recovery/${b64EncodeUnicode(this.recoveryuser)}`, { headers }).subscribe((result: LoginExtranetAppModel) => {
        if (result.HasAlert)
          this.login.setAlert(result.Alert);
        else {
          this.login.setAlert(`Mot de passe envoyé avec succès pour ${this.recoveryuser}, pensez à vérifier vos spams !`);
          this.backLogin();
        }
        this.indParam.showSplash(false);
      }));
    }
  }

  private checkRecovery(): boolean {
    this.recoveryuseralert = this.recoveryuser === '' ? 'Nom d\'utilisateur obligatoire' : '';
    this.recoverymailalert = this.recoverymail === '' ? 'email obligatoire' : '';
    this.recoverydbalert = this.recoverydb === '' ? 'db obligatoire' : '';
    return this.recoveryuseralert === '' && this.recoverymailalert === '' && this.recoverydbalert === '';
  }

  private sendAlert(alertmsg: string = ''): void {
    if (alertmsg !== '' && alertmsg !== 'OK') {
      switch (alertmsg) {
        case 'ERR DB':
          this.clientDB = '';
          this.showInputDB = this.inputData.CheckDB && this.clientDB === '';
          this.login.setAlert(`Le nom de la base de données fourni ${this.clientDB} n'existe pas`);
          break;
        case 'ERR US': this.login.setAlert('Veuillez vérifier votre login et mot de passe'); break;
        default: this.login.setAlert(alertmsg); break;
      }
    }
  }
}
